import React from 'react'
import { useNavigate } from 'react-router-dom'

import styles from './Forbidden.module.css'
import ForbiddenImage from './403.svg'

import Heading from 'Design/components/Heading'
import Button from 'Design/components/Button'

const Forbidden = () => {
  const navigate = useNavigate()

  const handleButtonClick = () => {
    navigate('/b/dashboard', { replace: true })
  }

  return (
    <div className={styles.GridContainer}>
      <div className={styles.Container}>
        <ForbiddenImage height='200' width='450' />
        <Heading>
          You don't have permission to <br /> access this page
        </Heading>
        <Button variant='primary' onClick={handleButtonClick}>
          Go to dashboard
        </Button>
      </div>
    </div>
  )
}

export default Forbidden
